<template>
  <main class="main h-100 w-100" style="background: #f4f7fc">
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-sm-10 col-md-7 col-lg-5 mx-auto d-table h-100">
          <div class="d-table-cell align-middle">
            <div class="card mt-5">
              <div class="card-body" id="invited_form" v-if="step == 1">
                <div class="text-center">
                  <logo />
                </div>
                <h3 class="text-center mt-4 text-muted fw-medium">
                  Forgot Your Password?
                </h3>
                <p class="text-center">Enter a new password below.</p>
                <alert v-if="has_error" type="danger">
                  Failed. Invalid data provided. Please contact support.
                </alert>
                <form @submit.prevent="submit">
                  <div class="mb-3">
                    <label>Full Name</label>
                    <input
                      type="text"
                      v-model="user.name"
                      placeholder="Full Name"
                      name="name"
                      class="form-control"
                    />
                  </div>
                  <div class="mb-3">
                    <label>Enter New Password</label>
                    <password
                      v-model="user.password"
                      placeholder="New Password"
                      name="password"
                    />
                  </div>
                  <div class="mb-3">
                    <label>Confirm New Password</label>
                    <password
                      v-model="user.password_confirmation"
                      placeholder="Confirm Password"
                      name="password_confirmation"
                    />
                  </div>
                  <div class="text-center">
                    <button class="btn btn-primary btn-lg">
                      Submit <i class="fal fa-sign-in me-0 ms-2"></i>
                    </button>
                  </div>
                </form>
              </div>
              <div class="card-body text-center" v-if="step == 2">
                <div class="t">
                  <logo />
                </div>
                <h3 class="mt-4 text-muted fw-medium">
                  Success!
                </h3>
                <p>Your password has been changed successfully.</p>
                <router-link :to="{ name: 'login' }" class="btn btn-primary btn-lg">Proceed To Login <i class="fal fa-sign-in me-0 ms-2"></i></router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  mounted() {
    if (this.$storage.has("token")) {
      this.$router.push({ name: "main" });
    }
  },
  
  data() {
    return {
      user: {},
      step: 1,
      has_error: false,
    };
  },

  methods: {
    submit() {
      this.step = 1
      this.has_error = 0

      let data = {
        form_id: "invited_form",
        name: this.user.name,
        password: this.user.password,
        password_confirmation: this.user.password_confirmation,
        token: this.$route.params.token,
      };

      this.$axios
        .post("/api/v1/invited-user", data)
        .then(() => {
          this.step = 2
          this.has_error = 0
        })
        .catch(() => {
          this.step = 1
          this.has_error = 1
        });
    },
  },
};
</script>
